import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const searchDevices = createAsyncThunk('search', async ({ searchKey, groupId }, { getState, rejectWithValue }) => {
    try {
        // configure header's Content-Type as JSON
        const { auth } = getState();
        const config = {
            headers: {
                Authorization: `Token ${auth.userToken}`
            }
        };
        const timezoneOffSet = new Date().getTimezoneOffset();

        const { data } = await axios.get(`/api/management/device_search?keyword=${searchKey}&tz=${-timezoneOffSet}&id=${groupId}`, config);
        return data;
    } catch (error) {
        // return custom error message from API if any
        if (error.response.status === 500) {
            toast.error('Server Error!');
            return rejectWithValue(error.response.data.message);
        } else {
            toast.error(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
});
